import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CircleCheck",
  "use": "CircleCheck-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"CircleCheck\"><path d=\"M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16z\" fill=\"#031425\" /><path d=\"M11.869 5.694a.38.38 0 0 0-.418-.054.378.378 0 0 0-.117.09l-4.036 4.542-1.845-1.939a.38.38 0 0 0-.265-.117.383.383 0 0 0-.271.1.37.37 0 0 0-.018.528l2.135 2.24a.38.38 0 0 0 .556-.01l4.312-4.853a.372.372 0 0 0 .056-.41.372.372 0 0 0-.09-.117z\" fill=\"#fff\" stroke=\"#fff\" stroke-width=\".32\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol